import Scroll from './Scroll.vue'
export default Scroll


// WEBPACK FOOTER //
// ./src/components/Scroll/index.js